import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: { homeFeedPage: number, trenchesPostFeedPage: number, homeBroadcastPage: number , bookmarkPage : number} = {
    homeFeedPage: 0,
    trenchesPostFeedPage:0,
    homeBroadcastPage: 0,
    bookmarkPage : 0
};
export const PaginationSlice = createSlice({
    name: "pagination_slice",
    initialState,
    reducers: {
        setHomeFeedPage: (state, action: PayloadAction<number>) => {
            state.homeFeedPage = action.payload
        },
        setBroadcastFeedPage: (state, action: PayloadAction<number>) => {
            state.homeBroadcastPage = action.payload
        },
        setTrenchesPostFeedPage : (state, action: PayloadAction<number>) => {
            state.trenchesPostFeedPage = action.payload
        },
        setBookmarkPage : (state, action: PayloadAction<number>) => {
            state.bookmarkPage = action.payload
        },
    },
});
export const {
    setHomeFeedPage,
    setTrenchesPostFeedPage,
    setBroadcastFeedPage,
    setBookmarkPage
} = PaginationSlice.actions;

export default PaginationSlice.reducer;